import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import logo from '../../assets/logo.svg';

class Header extends Component {
  render() {
    return (
      <header className="header pt-3 pb-3">
        <Container className="text-center">
          <img src={logo} alt="Running heroes Logo" />
        </Container>
      </header>
    );
  }
}

export default Header;
